import React, {useState, useEffect} from "react";
import {
    FaShare,
    FaArrowUp,
    FaChartLine,
    FaClock,
    FaFire,
    FaHeart,
    FaComment,
    FaEthereum,
    FaArrowDown
} from "react-icons/fa6";
import {FaArrowLeft} from "react-icons/fa";
import SignalsService from "../../services/Signals";
import {useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectUser} from "../../redux/slices/userSlice";
import ProfileFunction from "../../functions/profileFunction/ProfileFunction";
import fixDate from "../../components/DateFormatter/FixDate";
import defaultProfilePic from "../../assets/images/anonymous.jpg.webp"
import {motion, AnimatePresence} from "framer-motion";
import {FaXmark} from "react-icons/fa6";

function CommentItem({c, IMAGE_BASE}) {
    return (
        <div className="flex items-start space-x-3">
            <img
                src={c?.author?.imageId?.path ? IMAGE_BASE + c.author.imageId.path : defaultProfilePic}
                className="w-8 h-8 rounded-full"
                alt={c?.author?.fullName}
            />
            <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                    <h4 className="font-medium text-sm">{c?.author?.fullName}</h4>
                    <span className="text-xs text-gray-500">{fixDate(c?.createdAt)}</span>
                </div>
                <p className="text-sm text-gray-700">{c?.content}</p>
            </div>
        </div>
    );
}



export default function SignalDetails() {

    const [isLiked, setIsLiked] = useState(false);
    const [likeCount, setLikeCount] = useState(0);
    const [commentText, setCommentText] = useState("");
    const [commentCount, setCommentCount] = useState(0);
    const [signalDetails, setSignalDetails] = useState(null);
    const [isAccess, setIsAccess] = useState(false);
    const [confidence, setConfidence] = useState(0);
    const [risk, setRisk] = useState(0);
    const [timeFrame, setTimeFrame] = useState(null);
    const IMAGE_BASE = process.env.REACT_APP_BASE_URL_IMAGE;
    const [showAllComments, setShowAllComments] = useState(false);

    const userData = useSelector(selectUser)
    ProfileFunction()

    const {id} = useParams();

    async function fetchSignalDetails() {
        try {
            const response = await SignalsService.getSignalById(id);
            setIsAccess(true)
            setSignalDetails(response?.data?.data);
            setIsLiked(response?.data?.data?.isLiked || false);
            setLikeCount(response?.data?.data?.likesCount || 0);
            setCommentCount(response?.data?.data?.commentsCount || 0);
            setConfidence(response?.data?.data?.confidence || 0);
            setRisk(response?.data?.data?.risk || 0);
            setTimeFrame(response?.data?.data?.timeframe);
            console.log("Signal Details:", response.data);
        } catch (error) {
            console.error("Failed to fetch signal details:", error);
        }
    }

    useEffect(() => {
        fetchSignalDetails();
        fetchComments();
    }, [id]);

    useEffect(() => {
        document.body.style.overflow = showAllComments ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [showAllComments]);

    const [comments, setComments] = useState([]);
    const fetchComments = async () => {
        try {
            const response = await SignalsService.getSignalComments(id);
            setComments(response?.data?.data || []);
            console.log("Signal Comments:", response.data);
        } catch (error) {
            console.error("Failed to fetch signal comments:", error);
        }
    };

    const shareSignal = async () => {
        try {
            if (navigator.share) {
                await navigator.share({
                    title: "BTC/USDT Signal",
                    text: "Check out this trading signal from Silver Strategy",
                    url: window.location.href,
                });
            } else {
                await navigator.clipboard.writeText(window.location.href);
                alert("Signal link copied to clipboard!");
            }
        } catch (e) {
            console.error(e);
        }
    };


    const goBack = () => window.history.back();

    const sendComment = async () => {
        const body = {
            targetId: id,
            content: commentText
        };
        console.log("send comment body", body);
        try {
            const res = await SignalsService.postSignalComment(body)
            if (res.status === 200) {
                setCommentCount((prev) => prev + 1);
            }
            console.log("send comment res", res)
        } catch (err) {
            console.log("error in sending comment", err)
        }
        setCommentText("");
        fetchComments();
    };

    const toggleLikeSignal = async () => {
        try {
            const newLikedState = !isLiked;
            setIsLiked(newLikedState);

            if (newLikedState) {
                await SignalsService.likeSignal({id});
                setLikeCount((prev) => prev + 1);
            } else {
                await SignalsService.disLikeSignal({id});
                setLikeCount((prev) => prev - 1);
            }
        } catch (error) {
            console.error("Failed to toggle like:", error);
            setIsLiked((prev) => !prev);
        }
    };

    function calculateRemainingDays(expirationDate) {
        if (!expirationDate) return 0;

        const now = new Date();
        const exp = new Date(expirationDate);

        const diffTime = exp - now;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 0;
    }

    if (!isAccess) {
        return;
    }


    return (

        <>


            <div className="min-h-screen bg-gray-50 font-sans">
                {/* Header */}
                <header className="bg-white px-4 py-4 fixed top-0 left-0 right-0 shadow-sm z-50">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                            <button
                                onClick={goBack}
                                className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors"
                            >
                                <FaArrowLeft className="text-gray-600"/>
                            </button>
                            <h1 className="text-xl font-bold text-gray-900">Signal Details</h1>
                        </div>
                        <button
                            onClick={shareSignal}
                            className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-50 hover:bg-indigo-200 transition-colors"
                        >
                            <FaShare className="text-indigo-600"/>
                        </button>
                    </div>
                </header>

                <main className="pt-20 pb-24">
                    <motion.div
                        initial={{opacity: 0, y: 24}}
                        animate={{opacity: 1, y: 0}}
                        transition={{duration: 0.45}}
                        className="w-full px-4 space-y-6"
                    >
                        <section className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden p-5">
                            <div className="flex items-start justify-between mb-4">
                                <div className="flex items-center">
                                    <img
                                        className="w-16 h-16 rounded-full mr-3"
                                        src={`https://api.7-trade.ir/${signalDetails?.image?.path}`}
                                        alt="BTC/USDT"
                                    />
                                    <div>
                                        <h4 className="font-bold text-xl">{signalDetails?.symbol?.symbol || '-'}</h4>
                                        <p className="text-sm text-gray-600">{signalDetails?.description || '-'}</p>
                                    </div>
                                </div>
                                <span
                                    className={`text-sm font-bold px-4 py-2 rounded-full flex items-center ${signalDetails?.type === 'buy' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                    }`}>
                                {signalDetails?.type === 'buy' ? <FaArrowUp className="mr-2"/> :
                                    <FaArrowDown className="mr-2"/>}
                                    {signalDetails?.type === 'buy' ? 'BUY' : 'SELL'}
                            </span>
                            </div>

                            {/* Price Info */}
                            <div className="grid grid-cols-2 gap-4 mb-5">
                                <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                    <p className="text-xs text-gray-600 mb-1">Current Price</p>
                                    <p className="font-bold text-green-600 text-lg">${signalDetails?.currentPrice || 450}</p>
                                    <p className="text-xs text-green-600">+4.3%</p>
                                </div>
                                <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                                    <p className="text-xs text-gray-600 mb-1">Entry Price</p>
                                    <p className="font-bold text-lg">${signalDetails?.trigger?.target || 400}</p>
                                </div>
                            </div>

                            {/* Targets */}
                            <div className="mb-5">
                                <p className="text-sm font-semibold text-gray-600 mb-3">
                                    Take Profit Targets
                                </p>
                                <div className="flex space-x-3 overflow-x-auto pb-2 no-scrollbar">
                                    {signalDetails?.tp.map((target, i) => (
                                        <div
                                            key={i}
                                            className="flex bg-emerald-50 p-3 rounded-lg border border-emerald-200 min-w-[140px]"
                                        >
                                            {/* <div className="flex items-center mb-2"> */}
                                            <div
                                                className="w-6 h-6 bg-emerald-500 text-white rounded-full flex items-center justify-center text-xs font-bold mr-2">
                                                {i + 1}
                                            </div>
                                            {/* <span
                                                className={`text-xs px-2 py-1 rounded-full font-semibold ${i === 1
                                                    ? "bg-emerald-100 text-emerald-700"
                                                    : i === 2
                                                        ? "bg-yellow-100 text-yellow-700"
                                                        : "bg-gray-100 text-gray-600"
                                                    }`}
                                            >
                                                {i === 1 ? "Hit" : "Pending"}
                                            </span> */}
                                            <p className="font-bold text-emerald-600">
                                                ${target?.target}
                                            </p>
                                            {/* </div> */}

                                            {/* <p className="text-xs text-emerald-600">
                                            +${1700 + i * 900}
                                        </p> */}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Stop Loss */}
                            <div className="bg-red-50 p-4 rounded-lg border border-red-200 mb-4">
                                <p className="text-xs text-gray-600 mb-1">Stop Loss (SL)</p>
                                <p className="font-bold text-red-600 text-lg">{signalDetails?.sl?.target || 0}</p>
                                {/* <p className="text-xs text-red-600">-$400</p> */}
                            </div>

                            {/* Time Info */}
                            <div className="bg-orange-50 p-4 rounded-lg border border-orange-200 mb-4">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <p className="text-xs text-gray-600 mb-1">Time Remaining</p>
                                        <p className="font-bold text-orange-600">{calculateRemainingDays(signalDetails?.expirationDate)}</p>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-xs text-gray-600 mb-1">Expire At</p>
                                        <p className="font-bold text-orange-600">{fixDate(signalDetails?.expirationDate)}</p>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Stats */}
                        <section className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
                            <div className="grid grid-cols-3 gap-4">
                                <div className="text-center">
                                    <FaChartLine className="text-green-500 text-xl mx-auto mb-2"/>
                                    <p className="text-2xl font-bold text-green-600">+4.3%</p>
                                    <p className="text-sm text-gray-500">Current Profit</p>
                                </div>
                                <div className="text-center border-x border-gray-100">
                                    <FaClock className="text-yellow-500 text-xl mx-auto mb-2"/>
                                    <p className="text-2xl font-bold text-gray-900">1h 23m</p>
                                    <p className="text-sm text-gray-500">Duration</p>
                                </div>
                                <div className="text-center">
                                    <p className="text-indigo-500 font-bold text-2xl mx-auto">%</p>
                                    <p className="text-2xl font-bold text-gray-900">87%</p>
                                    <p className="text-sm text-gray-500">Success Rate</p>
                                </div>
                            </div>
                        </section>

                        {/* Package Info */}
                        <section className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-3">
                                    <img
                                        className="w-12 h-12 rounded-full border-2 border-gray-200"
                                        src={signalDetails?.ownerId?.imageId?.path? IMAGE_BASE + signalDetails.ownerId.imageId.path : defaultProfilePic}
                                        alt={signalDetails?.fullName || '-'}
                                    />
                                    <div>
                                        <h3 className="font-bold text-gray-900">{signalDetails?.ownerId?.fullName || '-'}</h3>
                                        <p className="text-sm text-gray-600">by {signalDetails?.ownerId?.fullName || '-'}</p>
                                        {/* <p className="text-xs text-gray-500">
                                        Strategy Expert • 2.1k followers
                                    </p> */}
                                    </div>
                                </div>
                                {/* <button className="bg-primary text-white flex items-center justify-center pt-3 px-5 py-2 rounded-lg font-medium hover:bg-indigo-700 transition-colors">
                                Follow
                            </button> */}
                            </div>
                        </section>

                        {/* Signal Analysis */}
                        <section className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
                            <h3 className="font-bold text-lg mb-3">Signal Analysis</h3>
                            <div className="space-y-3">
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-600">Risk Level</span>
                                    <div className="flex items-center space-x-2">
                                        <div className="w-20 h-2 bg-gray-200 rounded-full">
                                            <div style={{width: `${risk}%`}}
                                                 className={`h-2 ${risk < 35 ? 'bg-green-500' : risk < 70 ? 'bg-yellow-500' : 'bg-red-500'} rounded-full`}></div>
                                        </div>
                                        <span
                                            className={`text-sm font-medium ${risk < 35 ? 'text-green-500' : risk < 70 ? 'text-yellow-500' : 'text-red-500'}`}>
                                        {risk ? `${risk}%` : '-'}
                                    </span>
                                    </div>
                                </div>
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-600">Confidence</span>
                                    <div className="flex items-center space-x-2">
                                        <div className="w-20 h-2 bg-gray-200 rounded-full">
                                            <div style={{width: `${confidence}%`}}
                                                 className={`h-2 ${confidence < 35 ? 'bg-red-500' : confidence < 70 ? 'bg-yellow-500' : 'bg-green-500'} rounded-full`}></div>
                                        </div>
                                        <span
                                            className={`text-sm font-medium ${confidence < 35 ? 'text-red-500' : confidence < 70 ? 'text-yellow-500' : 'text-green-500'}`}>
                                        {confidence ? `${confidence}%` : '-'}
                                    </span>
                                    </div>
                                </div>
                                <div className="flex justify-between items-center">
                                    <span className="text-gray-600">Time Frame</span>
                                    <span className="font-medium">{timeFrame || '-'}</span>
                                </div>
                            </div>
                        </section>

                        {/* Interaction */}
                        <section className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
                            <div className="flex items-center justify-between mb-4">
                                <div className="flex items-center space-x-6">
                                    <button
                                        onClick={toggleLikeSignal}
                                        className="flex items-center space-x-2 group"
                                    >
                                        <FaHeart
                                            className={`text-xl transition-colors ${isLiked ? "text-red-500" : "text-gray-400"
                                            }`}
                                        />
                                        <span className="font-medium text-gray-600">{likeCount || 0}</span>
                                    </button>
                                    <div className="flex items-center space-x-2">
                                        <FaComment className="text-gray-400 text-xl"/>
                                        <span className="font-medium text-gray-600">{commentCount || 0}</span>
                                    </div>
                                </div>
                                <button
                                    onClick={() => setShowAllComments(true)}
                                    className="text-indigo-600 font-medium text-sm"
                                >
                                    All
                                </button>
                            </div>

                            {/* Comment box */}
                            <div className="border-t border-gray-100 pt-4">
                                <div className="flex items-center space-x-3">
                                    <img
                                        className="w-8 h-8 rounded-full"
                                        src={`https://api.7-trade.ir${userData?.imageId?.path}`}
                                        alt="You"
                                    />
                                    <input
                                        value={commentText}
                                        onChange={(e) => setCommentText(e.target.value)}
                                        placeholder="Add a comment..."
                                        className="flex-1 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400"
                                    />
                                    <button
                                        onClick={sendComment}
                                        className="bg-primary text-white px-5 py-2 pt-3 rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors"
                                    >
                                        Post
                                    </button>
                                </div>
                            </div>
                        </section>

                        {/* 💬 Recent Comments */}
                        <section className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
                            <h3 className="font-bold text-lg mb-4">Recent Comments</h3>
                            {comments.length === 0 ? (
                                <p className="text-sm text-gray-500">No comments yet.</p>
                            ) : (
                                <div className="space-y-4">
                                    {comments.slice(0, 2).map((c) => (
                                        <CommentItem key={c?._id} c={c} IMAGE_BASE={IMAGE_BASE}/>
                                    ))}
                                </div>
                            )}
                            {comments.length > 2 && (
                                <button
                                    onClick={() => setShowAllComments(true)}
                                    className="mt-4 w-full text-center text-indigo-600 font-medium text-sm"
                                >
                                    View all {comments.length} comments
                                </button>
                            )}
                        </section>

                        {/* 🔁 More from Silver Strategy */}
                        <section className=" rounded-xl p-4">
                            <h3 className="font-bold text-lg mb-2">More from Silver Strategy</h3>
                            <p className="text-sm text-gray-500 mb-3">
                                Other signals from this package
                            </p>
                            <div className="space-y-3">
                                <div
                                    className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div
                                            className="bg-gray-100 h-10 w-10 rounded-lg flex items-center justify-center">
                                            <FaFire className="text-red-400"/>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold">EUR/USD</h4>
                                            <p className="text-sm text-gray-500">Forex Signal</p>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                    <span className="bg-red-100 text-red-700 text-xs px-2 py-1 rounded-full">
                                        SELL
                                    </span>
                                        <p className="text-sm font-semibold text-green-600 mt-1">
                                            +2.1%
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                        <div
                                            className="bg-gray-100 h-10 w-10 rounded-lg flex items-center justify-center">
                                            <FaEthereum className="text-blue-500"/>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold">ETH/USDT</h4>
                                            <p className="text-sm text-gray-500">Crypto Signal</p>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                    <span className="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full">
                                        BUY
                                    </span>
                                        <p className="text-sm font-semibold text-green-600 mt-1">
                                            +3.7%
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </motion.div>
                </main>
                <AnimatePresence>
                    {showAllComments && (
                        <>
                            {/* Backdrop */}
                            <motion.div
                                key="backdrop"
                                className="fixed inset-0 bg-black/40 z-[60]"
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                onClick={() => setShowAllComments(false)}
                            />

                            {/* Sheet */}
                            <motion.div
                                key="sheet"
                                className="fixed bottom-0 left-0 right-0 z-[70] bg-white rounded-t-3xl shadow-2xl flex flex-col max-h-[80vh]"
                                initial={{y: "100%"}}
                                animate={{y: 0}}
                                exit={{y: "100%"}}
                                transition={{type: "spring", damping: 30, stiffness: 300}}
                                drag="y"
                                dragConstraints={{top: 0, bottom: 0}}
                                dragElastic={{top: 0, bottom: 0.6}}
                                onDragEnd={(_, info) => {
                                    if (info.offset.y > 100 || info.velocity.y > 500) {
                                        setShowAllComments(false);
                                    }
                                }}
                            >
                                {/* Handle + header */}
                                <div className="px-4 pt-3 pb-3 border-b border-gray-100">
                                    <div className="w-10 h-1.5 bg-gray-300 rounded-full mx-auto mb-3"/>
                                    <div className="flex items-center justify-between">
                                        <h3 className="font-bold text-lg">Comments ({comments.length})</h3>
                                        <button
                                            onClick={() => setShowAllComments(false)}
                                            className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
                                        >
                                            <FaXmark className="text-gray-600"/>
                                        </button>
                                    </div>
                                </div>

                                {/* Scrollable list */}
                                <div className="overflow-y-auto px-4 py-4 space-y-4 flex-1">
                                    {comments.length === 0 ? (
                                        <p className="text-sm text-gray-500 text-center py-6">No comments yet.</p>
                                    ) : (
                                        comments.map((c) => (
                                            <CommentItem key={c?._id} c={c} IMAGE_BASE={IMAGE_BASE}/>
                                        ))
                                    )}
                                </div>
                            </motion.div>
                        </>
                    )}
                </AnimatePresence>
            </div>
        </>
    );
}
